module.exports = __webpack_public_path__ + "discount.8649d602.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/community_tabs/discount.png
// module id = 346
// module chunks = 0